<template>
  <b-container fluid id="project" class="page">
    <h1>{{ this.page.display_title }}</h1>
    <b-nav vertical>
      <b-nav-item disabled>Contents</b-nav-item>
      <b-nav-item v-scroll-to="'#Abstract'">Abstract</b-nav-item>
      <b-nav-item v-scroll-to="'#Members'">Members</b-nav-item>
      <b-nav-item v-scroll-to="'#Partners'">Partners</b-nav-item>
      <b-nav-item
        v-if="filteredPublications.length > 0"
        v-scroll-to="'#Publications'"
        >Publications</b-nav-item
      >
      <b-nav-item v-if="newsToShow.length > 0" v-scroll-to="'#News'"
        >News</b-nav-item
      >
      <b-nav-item v-scroll-to="'#Acknowledgements'"
        >Acknowledgements</b-nav-item
      >
    </b-nav>

    <div class="content">
      <div class="project-section">
        <div id="Abstract"></div>
        <h2>Abstract</h2>
        <div class="mb-3">
          <span>
            <font-awesome icon="calendar" fixed-width />
          </span>
          <span>{{ this.page.begins_at }} - {{ this.page.ends_at }}</span>
        </div>
        <p class="richtext" v-html="this.page.content"></p>

        <a
          v-if="this.page.external_url.length > 0"
          :href="this.page.external_url"
          :target="_blank"
        >
          <b-button variant="primary">More Info</b-button>
        </a>
      </div>
      <div class="member-section">
        <div id="Members"></div>
        <h2>Members</h2>
        <b-row>
          <b-col
            v-for="member in orderedMembers"
            :key="member.id"
            cols="4"
            md="3"
            lg="2"
          >
            <member :member_data="member"></member>
            <h6 v-if="lead_researcher && lead_researcher.id === member.id" class="mt-0"> Lead Researcher </h6>
          </b-col>
        </b-row>
      </div>
      <div
        v-if="this.page.project_partners.length != 0"
        class="project-section"
        id="Partners"
      >
        <h2>Partners</h2>
        <ul class="partners-list">
          <li v-for="item in this.page.project_partners" v-bind:key="item.name">
            <span>
              <font-awesome icon="square" />
            </span>
            <a
              v-if="item.url"
              :href="item.url"
              target="_blank"
              rel="noopener noreferrer"
              >{{ item.name }}</a
            >
            <div v-else>{{ item.name }}</div>
          </li>
        </ul>
      </div>
      <div
        v-if="filteredPublications.length > 0"
        class="project-section publications"
        id="Publications"
      >
        <div
          class="title d-flex justify-content-start align-items-center flex-wrap"
        >
          <h2>Publications</h2>
          <b-form-select
            v-model="selected"
            :options="options"
            id="dropdown-publications-years"
            class="m-md-2"
          ></b-form-select>
        </div>

        <h4>{{ selected }}</h4>

        <ul class="publications-list">
          <li
            v-for="publication in filteredPublications"
            v-bind:key="publication.pub_authenticus_id"
            style="margin-bottom: 1em"
          >
            <span class="bullet-point">
              <font-awesome icon="square" />
            </span>
            <div class="publication-info">
              <a
                class="d-flex"
                v-b-popover.hover.right="'See in Authenticus'"
                v-bind:href="
                  'https://www.authenticus.pt/' + publication.pub_authenticus_id
                "
                target="_blank"
              >
                <!--<p class="pub-header pub-header-title">Title:&nbsp;</p>-->
                <p
                  class="pub-header"
                  style="margin-bottom: 5px; height: inherit"
                >
                  {{ publication.title }}
                </p>
              </a>

              <div class="d-flex">
                <div class="d-flex">
                  <!--<p class="pub-header">Authors:&nbsp;</p>-->
                  <p
                    class="pub-authors"
                    style="margin-bottom: 5px; font-size: 0.95em"
                  >
                    {{ publication.authorlist }}
                  </p>
                </div>

                <div class="d-flex ml-3">
                  <!--<p class="pub-header">Publication Year:&nbsp;</p>-->
                  <p style="margin-bottom: 5px; font-size: 0.95em">
                    ({{ publication.year }})
                  </p>
                </div>
              </div>

              <div class="d-flex" v-if="publication.pubtype == 'Article'">
                <p
                  style="
                    font-style: italic;
                    margin-bottom: 5px;
                    font-size: 0.95em;
                  "
                >
                  {{ publication.source }} (vol. {{ publication.volume }})
                </p>
              </div>
              <div
                class="d-flex"
                v-else-if="
                  publication.pubtype == 'Proceedings Paper' &&
                  publication.conference
                "
              >
                <p
                  style="
                    font-style: italic;
                    margin-bottom: 5px;
                    font-size: 0.95em;
                  "
                >
                  {{ publication.conference }}
                </p>
              </div>
              <div class="d-flex" v-else>
                <p
                  style="
                    font-style: italic;
                    margin-bottom: 5px;
                    font-size: 0.95em;
                  "
                >
                  {{ publication.source }}
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div id="News">
        <h2>News</h2>
        <div v-if="newsToShow.length !== 0">
          <div v-for="article in newsToShow" :key="article.id" id="related-news" class="my-4">
            <piece :article_data="article"></piece>
          </div>
        </div>
        <div v-else id="no-data" class="d-flex">
          <span><font-awesome icon="exclamation" fixed-width /></span>
          <p>No articles have been added yet!</p>
        </div>

        <b-button
          @click="loadMoreNews"
          variant="primary"
          v-if="itemsToShow < related_news.length"
          class="show-all-button"
          >Load More News</b-button
        >
      </div>
      <div
        id="Acknowledgements"
        v-if="this.page.acknowledgements !== empty"
        class="project-section my-4"
      >
        <h2>Acknowledgements</h2>
        <p v-html="this.page.acknowledgements"></p>
      </div>
    </div>
  </b-container>
</template>

<script>
import Member from "@/components/Member.vue";
import Piece from "@/components/Article.vue";

export default {
  name: "Project",
  props: ["page"],
  components: {
    Member,
    Piece,
  },
  data() {
    const buildFilterEntry = (year) => {
      return { value: year, text: year };
    };
    const filters = this.page.filter_years.map((year) =>
      buildFilterEntry(year)
    );
    filters.sort((entry1, entry2) => entry2.value - entry1.value);
    filters.unshift({ value: "All", html: "All" });
    return {
      publications: this.page.project_publications,
      empty: '<div class="rich-text"></div>',
      selected: "All",
      options: filters,
      related_news: this.page.related_news,
      itemsToShow: 5,
      lead_researcher: this.page.lead_researcher
    };
  },
  methods: {
    handleScroll() {
      let header = document.querySelector(".nav.flex-column");
      if (header != null)
        if (window.scrollY > 0 && window.innerWidth > 1200)
          header.classList.add("fixed-nav");
        else header.classList.remove("fixed-nav");
    },
    loadMoreNews() {
      this.itemsToShow += 5;
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  computed: {
    filteredPublications() {
      return this.publications
        .filter(
          (publication) =>
            "All" === this.selected || publication.year === this.selected
        )
        .sort((entry1, entry2) => entry2.year - entry1.year);
    },
    newsToShow() {
      return this.related_news.slice(0, this.itemsToShow);
    },
    orderedMembers() {
      if (!this.lead_researcher) {
        return this.page.project_members;
      }

      return [
        this.lead_researcher,
        ...this.page.project_members.filter(
          m => m.id !== this.lead_researcher.id
        )
      ];
    },
  },
};
</script>

<style lang="scss">
.member-position {
  display: none;
}
#project {
  h1 {
    margin-bottom: 1.2em;
  }
  h2 {
    color: $secondary-color;
    margin-bottom: 0.6em;
  }
  span {
    font-size: 1.2em;
    text-transform: uppercase;
    * {
      color: $secondary-color;
      margin-right: 1em;
    }
  }

  .fixed-nav {
    left: calc(100% - 5em - 106.28px);
    position: fixed !important;
    top: calc(9em + 48px + 3em);
  }
  .nav {
    border-left: 5px solid $primary-color;
    padding-left: 0.8em;
    float: right;
    a.nav-link {
      color: black;
      padding: 0;
      transition: all 0.2s ease-in;
      &.disabled {
        font-weight: 500 !important;
      }
      &:hover {
        color: $secondary-color !important;
      }
    }
  }
  .content {
    width: 90%;
    .project-section:not(:last-child) {
      margin-bottom: 4em;
    }
    .member-section:not(:last-child) {
      margin-bottom: 4em;
      h6 {
        color: $primary-color;
      }
    }
    .publications {
      .title {
        margin: 3em 0 1em 0;
      }
      h2 {
        margin: 0 4.2em 0 0;
      }

      h4 {
        color: $secondary-color;
        text-transform: uppercase;
      }

      @include media-breakpoint-down(sm) {
        .title {
          margin-bottom: 3em;
        }
        h2 {
          margin-bottom: 0.5em;
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  #project {
    h1 {
      margin-bottom: 0.8em;
    }
    .nav {
      float: none;
      margin-bottom: 2.2em;
    }
  }
}

#news {
  #related-news {
    > * {
      margin-bottom: 4em !important;
    }

    :last-child {
      margin-bottom: 0;
    }

    :first-child {
      margin-top: 1em;
    }
  }

  .loading-animation {
    position: relative;
    transform: scale(0.6);
  }

  .load-more-button.bottom {
    display: block !important;
    margin-top: 8em !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .load-more-button.top {
    display: block !important;
    margin-bottom: 2em !important;
    margin-top: 2em !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
}

.show-all-button {
  display: block;
  margin-top: 2em;
  margin-left: auto;
  margin-right: auto;
}
</style>
